<div class="spacing" *ngIf="!loading && subscriptions">
  <table class="mat-elevation-z8 grayBackground" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="benefitName">
      <th mat-header-cell *matHeaderCellDef> Benefit </th>
      <td mat-cell *matCellDef="let subscription"> {{subscription.benefitName}} </td>
    </ng-container>
    <ng-container matColumnDef="cycleStateName">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let subscription"> {{subscription.cycleStateName}} </td>
    </ng-container>
    <ng-container matColumnDef="cycleStartTime">
      <th mat-header-cell *matHeaderCellDef> Start Date </th>
      <td mat-cell *matCellDef="let subscription"> {{subscription.cycleStartTime | date: 'MMMM d, yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell *matHeaderCellDef> Expiration Date </th>
      <td mat-cell *matCellDef="let subscription"> {{subscription.expirationDate | date: 'MMMM d, yyyy'}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
  </table>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
